import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import cns from '../../node_modules/classnames/index.js';
import { Component } from 'react';
import ErroreIcon from '../Icons/ErroreIcon.js';
import Badge from '../Badge/Badge.js';
import Spinner from '../Spinner/Spinner.js';
import Tabs from '../Tabs/Tabs.js';
import HeaderOperazione from './HeaderOperazione.js';
import HeaderMassiva from './HeaderMassiva.js';
import TabellaOperazioneSincrona from './TabellaOperazioneSincrona.js';
import DettaglioOperazioneMassiva from './DettaglioOperazioneMassiva.js';
import { isOperazioneWithTextCollapsed, Types, Timeout, StatoOperazione, MAX_TEXT_LENGTH } from './SnackbarUtils.js';
import doesNodeContainClick from '../Utils/doesNodeContainClick.js';
import TransitionGroup from '../../node_modules/react-transition-group/esm/TransitionGroup.js';
import CSSTransition from '../../node_modules/react-transition-group/esm/CSSTransition.js';

function createTransaction(item, disableAnimation, className) {
    return (jsx(TransitionGroup, { className: className, children: item && (jsx(CSSTransition, { component: "div", enter: !disableAnimation, exit: !disableAnimation, timeout: 500, classNames: "snackbar__animation", children: item })) }));
}
class SnackbarElement extends Component {
    constructor(props) {
        super(props);
        this.index = 0;
        this.mouseOver = false;
        this.removeOnMouseOut = null;
        this.timeOut = null;
        this.locationHashChanged = () => {
            if (window.location.hash !== this.location) {
                this.clearSync();
            }
        };
        this.closeifOpen = (e) => {
            const { expanded, operazioniMassive } = this.state;
            if (expanded) {
                if (operazioniMassive.length > 0) {
                    this.setState({
                        disableAnimation: true,
                    }, () => setTimeout(() => this.setState({
                        disableAnimation: false,
                    }), 100));
                }
                if (doesNodeContainClick(this.refList, e))
                    return;
                this.setState({
                    expanded: false,
                });
                this.clearExpand();
            }
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.show = (operazione) => {
            let newOp = Object.assign({}, operazione); // eslint-disable-line prefer-const
            if (isOperazioneWithTextCollapsed(operazione)) {
                newOp.confirm = true;
            }
            newOp.timeStamp = (new Date(Date.now())).toISOString();
            newOp.index = this.index;
            this.index += 1;
            this.controllaHistoryOperazioni(newOp);
            this.mostraOperazione(newOp);
        };
        this.controllaHistoryOperazioni = (operazione) => {
            const { operazioneCorrente } = this.state;
            if (operazione.type === Types.ERROR && operazione.confirm) {
                const op = [];
                this.setState({
                    operazioniOneShot: op,
                });
            }
            else if (operazioneCorrente
                && operazioneCorrente.type === Types.ERROR && operazioneCorrente.confirm) {
                const op = [];
                op.push(operazioneCorrente);
                this.setState({
                    operazioniOneShot: op,
                });
            }
        };
        this.mostraOperazione = (operazione) => {
            const { expanded } = this.state;
            let t = operazione.timeout || Timeout[Object.keys(Timeout)[operazione.type]];
            if (expanded) {
                t = 0;
            }
            this.setState({
                operazioneCorrente: operazione,
            }, () => this.removeCurrent(t, operazione.index));
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.inizializzaOperazioni = (operazioni) => {
            this.setState({
                operazioniOneShot: operazioni.operazioni || [],
                operazioniMassive: operazioni.operazioniMassive || [],
                operazioneCorrente: operazioni.current || null,
                expanded: operazioni.expand || false,
            });
        };
        this.removeCurrent = (timeout, index, avoidStore) => {
            setTimeout(() => {
                const { operazioneCorrente } = this.state;
                if (operazioneCorrente && operazioneCorrente.index === index) {
                    if (!this.mouseOver) {
                        if (!avoidStore && operazioneCorrente.confirm) {
                            this.moveToHistory(operazioneCorrente);
                        }
                        this.setState({
                            operazioneCorrente: null,
                        });
                    }
                    else if (this.mouseOver) {
                        this.removeOnMouseOut = index;
                    }
                }
            }, timeout);
        };
        this.moveToHistory = (item) => {
            const { operazioniOneShot } = this.state;
            const tmpHistory = operazioniOneShot
                .concat(item)
                .sort((a, b) => a.index - b.index).reverse()
                .filter((x, i) => i < 10);
            this.setState({
                operazioniOneShot: tmpHistory,
            });
        };
        this.rimuoviOperazione = (index) => {
            const { operazioniOneShot } = this.state;
            const ops = operazioniOneShot
                .filter((x) => x.index !== index)
                .sort((a, b) => a.index - b.index).reverse();
            this.setState({
                operazioniOneShot: ops,
            });
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.clear = () => {
            this.setState({
                operazioniOneShot: [],
                operazioniMassive: [],
                operazioneCorrente: null,
                expanded: false,
            });
        };
        this.clearSync = () => {
            const { operazioneCorrente, operazioniOneShot } = this.state;
            const sync = operazioniOneShot.filter((x) => x.type !== Types.ERROR);
            const c = operazioneCorrente
                && operazioneCorrente.type === Types.ERROR ? null : operazioneCorrente;
            this.setState({
                operazioniOneShot: sync,
                operazioneCorrente: c,
            });
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.creaOperazioneMassiva = (operazione) => {
            const { operazioneCorrente, operazioniMassive } = this.state;
            let newOp = Object.assign({}, operazione); // eslint-disable-line prefer-const
            newOp.timeStamp = (new Date(Date.now())).toISOString();
            newOp.errori = operazione.errori || [];
            newOp.progresso = operazione.progresso || 0;
            newOp.conteggioErrori = 0;
            newOp.stato = StatoOperazione.PENDING;
            const operazioni = operazioniMassive;
            operazioni.push(newOp);
            if (operazioneCorrente && operazioneCorrente.confirm) {
                this.removeCurrent(0, operazioneCorrente.index);
            }
            setTimeout(() => this.setState({
                operazioniMassive: operazioni,
            }, () => this.mostraOperazione(newOp)), 50);
        };
        // eslint-disable-next-line class-methods-use-this, react/no-unused-class-component-methods
        this.tipoNotificaFineOperazioneMassiva = (numeroErrori) => (numeroErrori === 0 ? Types.SUCCESS : Types.WARNING);
        // eslint-disable-next-line class-methods-use-this
        this.calcolaProgresso = (progresso, selezionati) => (progresso / selezionati) * 100;
        this.completaOperazione = (id, progresso, testoFeedback, onFeedback) => {
            const { operazioniMassive } = this.state;
            const operazione = operazioniMassive.find((x) => x.id === id);
            if (!operazione) {
                return;
            }
            operazione.stato = StatoOperazione.COMPLETED;
            operazione.finishedTimestamp = (new Date()).toISOString();
            operazione.checked = true;
            operazione.elaborati = progresso;
            operazione.testoFeedback = testoFeedback;
            operazione.onFeedback = onFeedback;
            this.setState({
                operazioniMassive: operazioniMassive.filter((x) => x.id !== id).concat(operazione),
            });
        };
        this.aggiornaOperazione = (id, progresso) => {
            const { operazioniMassive } = this.state;
            const operazione = operazioniMassive.find((x) => x.id === id);
            operazione.progresso = this.calcolaProgresso(progresso, operazione.selezionati);
            const operazioni = operazioniMassive.filter((x) => x.id !== id).concat(operazione);
            this.setState({
                operazioniMassive: operazioni,
            });
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.aggiornaProgressoOperazione = (id, progresso) => {
            const { operazioniMassive } = this.state;
            const operazione = operazioniMassive.find((x) => x.id === id);
            if (!operazione || !operazione.selezionati) {
                return;
            }
            if (progresso === operazione.selezionati) {
                this.completaOperazione(id, progresso);
            }
            else {
                this.aggiornaOperazione(id, progresso);
            }
        };
        // eslint-disable-next-line react/no-unused-class-component-methods
        this.aggiungiErroreAOperazione = (id, err) => {
            const { operazioniMassive } = this.state;
            const operazione = operazioniMassive.find((x) => x.id === id);
            if (!operazione) {
                return;
            }
            const newError = Object.assign(Object.assign({}, err), { checked: false, deleted: false });
            operazione.errori.push(newError);
            const operazioni = operazioniMassive
                .filter((x) => x.id !== id)
                .concat(operazione);
            this.setState({
                operazioniMassive: operazioni,
            });
        };
        // eslint-disable-next-line class-methods-use-this, react/no-unused-class-component-methods
        this.ExtraActions = (type, actions) => actions;
        this.expand = () => {
            if (this.timeOut == null) {
                this.timeOut = setTimeout(this.realExpand, 2000);
            }
        };
        this.realExpand = (e) => {
            if (e) {
                e.stopPropagation();
            }
            const { operazioniOneShot, operazioniMassive } = this.state;
            if (operazioniOneShot.length > 0 || operazioniMassive.length > 0) {
                this.setState((prevState) => ({
                    expanded: !prevState.expanded,
                }));
                this.clearExpand();
            }
        };
        this.clearExpand = () => {
            if (this.timeOut) {
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }
        };
        this.onOperazioneBtnClick = (e, operazione) => {
            e.stopPropagation();
            const { operazioniMassive } = this.state;
            this.mouseOver = false;
            if (operazione.type === Types.MASSIVA && operazioniMassive.length > 0) {
                this.setState({
                    expanded: true,
                    disableAnimation: true,
                }, () => this.setState({
                    disableAnimation: false,
                }));
            }
            else if (operazione.type === Types.MASSIVA) {
                this.setState({
                    expanded: true,
                });
            }
            else if (isOperazioneWithTextCollapsed(operazione)) {
                this.setState({
                    disableAnimation: true,
                }, () => {
                    this.removeCurrent(0, operazione.index);
                    setTimeout(this.realExpand, 0);
                });
                setTimeout(() => this.setState({
                    disableAnimation: false,
                }), 50);
            }
            else {
                this.removeCurrent(0, operazione.index, true);
            }
        };
        this.segnaErroriOperazioneChecked = (idOperazione) => {
            const { operazioniMassive } = this.state;
            const operazione = operazioniMassive.find((x) => x.id === idOperazione);
            operazione.errori = operazione.errori.map((x) => {
                const err = x;
                err.checked = true;
                return err;
            });
            const om = operazioniMassive.filter((x) => x.id !== idOperazione).concat(operazione);
            this.setState({
                operazioniMassive: om,
            });
        };
        this.haErroriNonVisualizzati = () => {
            const { operazioniMassive } = this.state;
            return operazioniMassive.filter((x) => x.errori.filter((y) => !y.checked).length > 0).length > 0;
        };
        this.onMouseOver = () => {
            this.mouseOver = true;
        };
        this.onMouseOut = () => {
            this.mouseOver = false;
            if (this.removeOnMouseOut != null) {
                this.removeCurrent(0, this.removeOnMouseOut);
                this.removeOnMouseOut = null;
            }
        };
        this.onClick = (operazione) => {
            this.mouseOver = false;
            if ((!isOperazioneWithTextCollapsed(operazione)
                || !operazione.confirm)
                && operazione.type !== Types.MASSIVA) {
                return;
            }
            this.removeCurrent(0, operazione.index);
            this.setState({
                disableAnimation: true,
            }, () => setTimeout(this.realExpand, 0));
            setTimeout(() => this.setState({
                disableAnimation: false,
            }), 50);
        };
        this.visualizzaOperazione = () => {
            const { className } = this.props;
            const { operazioneCorrente, expanded, operazioniMassive } = this.state;
            const operazione = operazioneCorrente
                || operazioniMassive.find((x) => x.stato === StatoOperazione.COMPLETED && !x.checked)
                || operazioniMassive.find((x) => x.stato === StatoOperazione.PENDING);
            if (operazione == null) {
                return null;
            }
            const classes = cns('snackbar__item', {
                'snackbar__item--positive': operazione.type === Types.SUCCESS,
                'snackbar__item--error': operazione.type === Types.ERROR,
                'snackbar__item--warning': operazione.type === Types.WARNING,
                'snackbar__item--massiva': operazione.type === Types.MASSIVA && operazione.stato === StatoOperazione.PENDING,
                'snackbar__item--massivaFinished': operazione.type === Types.MASSIVA && operazione.stato === StatoOperazione.COMPLETED,
                snackbar__testoLungo: (Array.isArray(operazione.message) && operazione.message.length > 0)
                    ? (operazione.message[0].length > MAX_TEXT_LENGTH)
                    : (operazione.message.length > MAX_TEXT_LENGTH),
            }, className);
            return (jsxs("li", { className: classes, role: "presentation", onClick: () => this.onClick(operazione), onMouseOut: this.onMouseOut, onMouseOver: this.onMouseOver, onFocus: () => { }, onBlur: () => { }, children: [jsx(HeaderOperazione, { onOperazioneBtnClick: this.onOperazioneBtnClick, operazione: operazione }), jsx("div", { className: "snackbar__errorContainer", children: operazione.stato !== StatoOperazione.COMPLETED && this.haErroriNonVisualizzati()
                            && operazione.type === Types.MASSIVA && !expanded
                            && jsx(ErroreIcon, { className: "snackbar__iconHasError" }) }), operazione.stato === StatoOperazione.COMPLETED && operazione.errori.length > 0 && (jsx("div", { className: "snackbar__numeroErroriOperazione", children: jsx(Badge, { alarm: true, children: operazione.errori.length }) }))] }, operazione.index));
        };
        this.eliminaOperazioneAsync = (id) => {
            this.setState((prevState) => ({
                operazioniMassive: prevState.operazioniMassive.filter((x) => x.id !== id),
            }));
        };
        this.aggiornaStatoErrore = (opIndex, errId, cancel) => {
            const { operazioniMassive } = this.state;
            const operazioneMassiva = operazioniMassive.find((x) => x.id === opIndex);
            const errore = operazioneMassiva.errori.find((x) => x.id === errId);
            errore.checked = true;
            errore.deleted = cancel;
            const errori = operazioneMassiva.errori
                .filter((x) => x.id !== errId)
                .concat(errore);
            operazioneMassiva.errori = errori;
            operazioneMassiva.conteggioErrori += 1;
            const om = operazioniMassive
                .filter((x) => x.id !== opIndex)
                .concat(operazioneMassiva)
                .sort((a, b) => (new Date(a.timeStamp)).getTime() - (new Date(b.timeStamp)).getTime());
            this.setState({
                operazioniMassive: om,
            });
        };
        this.showExpandBar = () => {
            const { operazioneCorrente, expanded, operazioniMassive, operazioniOneShot, } = this.state;
            if (!operazioneCorrente
                && operazioniMassive.filter((x) => x.stato === StatoOperazione.PENDING).length === 0
                && ((operazioniOneShot.length > 0
                    || operazioniMassive.filter((x) => !x.deleted).length > 0) && !expanded)) {
                return true;
            }
            return false;
        };
        this.stampaTabOperazioniMassive = (operazioniMassive) => {
            const uniqueOperations = {};
            operazioniMassive.forEach((x) => {
                if (Object.prototype.hasOwnProperty.call(uniqueOperations, x.message)) {
                    const tmpArray = uniqueOperations[x.message]
                        .concat(x)
                        .sort((a, b) => (new Date(a.timeStamp)).getTime() - (new Date(b.timeStamp)).getTime());
                    uniqueOperations[x.message] = tmpArray;
                }
                else {
                    uniqueOperations[x.message] = [x];
                }
            });
            return Object.keys(uniqueOperations).map((x, i) => {
                const mostraSpinner = uniqueOperations[x]
                    .filter((op) => op.stato !== StatoOperazione.COMPLETED).length > 0;
                const errori = uniqueOperations[x].reduce((acc, val) => acc + val.errori.filter((op) => !op.checked).length, 0);
                return (jsx(Tabs.Tab, { className: "snackbar__tabOperazioniMassive", title: (jsxs("div", { children: [mostraSpinner && jsx(Spinner, { small: true }), x, errori > 0 && (jsx(Badge, { alarm: true, className: "snackbar__erroriOperazioneMassiva", children: errori }))] })), children: uniqueOperations[x].map((op, idx) => (jsx(DettaglioOperazioneMassiva, { aggiornaStatoErrore: this.aggiornaStatoErrore, eliminaOperazioneAsync: this.eliminaOperazioneAsync, onFeedback: op.onFeedback, operazione: op, segnaErroriOperazioneChecked: this.segnaErroriOperazioneChecked }, idx))) }, i));
            });
        };
        this.visualizzaOperazioni = () => {
            const { expanded, operazioniOneShot, operazioniMassive } = this.state;
            if (operazioniMassive.length > 0 && operazioniOneShot.length > 0) {
                return (jsxs("div", { className: "snackbar__operazioni", children: [jsx(HeaderMassiva, { operazioniMassive: operazioniMassive }), jsxs(Tabs, { className: "snackbar__tabs", children: [operazioniOneShot.map((x, i) => (jsx(Tabs.Tab, { title: "Errori", children: jsx(TabellaOperazioneSincrona, { operazione: x, rimuoviOperazione: this.rimuoviOperazione }) }, i))), this.stampaTabOperazioniMassive(operazioniMassive)] })] }));
            }
            if (operazioniOneShot.length === 1) {
                return (jsxs("div", { className: "snackbar__operazioni", children: [jsx(HeaderOperazione, { className: "snackbar__titoloHeader", expanded: expanded, operazione: operazioniOneShot[0] }), jsx(Tabs, { className: "snackbar__tabs", children: jsx(Tabs.Tab, { title: "Errori", children: jsx(TabellaOperazioneSincrona, { operazione: operazioniOneShot[0], rimuoviOperazione: this.rimuoviOperazione }) }) })] }));
            }
            if (operazioniMassive.length > 0) {
                return (jsxs("div", { className: "snackbar__operazioni", children: [jsx(HeaderMassiva, { operazioniMassive: operazioniMassive }), jsx(Tabs, { className: "snackbar__tabs", children: this.stampaTabOperazioniMassive(operazioniMassive) })] }));
            }
            return null;
        };
        this.state = {
            disableAnimation: false,
            expanded: false,
            operazioneCorrente: null,
            operazioniMassive: [],
            operazioniOneShot: [],
        };
    }
    componentDidMount() {
        this.index = 0;
        this.mouseOver = false;
        this.removeOnMouseOut = null;
        document.addEventListener('click', this.closeifOpen);
        this.location = window.location.hash;
        window.onhashchange = this.locationHashChanged;
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.closeifOpen);
    }
    render() {
        const _a = this.props, { className } = _a, others = __rest(_a, ["className"]);
        const { disableAnimation, expanded, operazioniOneShot, } = this.state;
        const classes = cns('snackbar', {
            snackbar__expand: expanded && operazioniOneShot.length > 0,
        }, className);
        const transactionComp = expanded
            ? createTransaction(this.visualizzaOperazioni(), disableAnimation, 'snackBar__items')
            : createTransaction(this.visualizzaOperazione(), disableAnimation, 'snackBar__current');
        return (jsx("div", Object.assign({ className: classes }, others, { children: jsxs("div", { className: "snackbar__container", ref: (r) => { this.refList = r; }, children: [transactionComp, this.showExpandBar() && (jsx("div", { className: "snackbar__expandBtn", role: "presentation", onClick: this.realExpand, onMouseOut: this.clearExpand, onMouseOver: this.expand, onFocus: () => { }, onBlur: () => { } }))] }) })));
    }
}
SnackbarElement.defaultProps = {
    className: '',
};
SnackbarElement.displayName = 'Snackbar';

export { SnackbarElement as default };
